<template>
  <div>
    <a-form
      class="simiot-nested-search-form"
      :form="form"
      @submit="handleSearch"
    >
      <a-row :gutter="24">
        <a-col :xl="8" :xxl="6">
          <a-form-item label="客户名称">
            <a-input
              v-decorator="['top_agent_name', { normalize: this.$lodash.trim }]"
              allow-clear
            />
          </a-form-item>
        </a-col>

        <a-col :xl="8" :xxl="6">
          <a-form-item label="最下级客户">
            <a-input
              v-decorator="['agent_name', { normalize: this.$lodash.trim }]"
              allow-clear
            />
          </a-form-item>
        </a-col>

        <a-col :xl="8" :xxl="6">
          <a-form-item label="订单号">
            <a-input
              v-decorator="['order_no', { normalize: this.$lodash.trim }]"
              allow-clear
              placeholder="商户/渠道订单号"
            />
          </a-form-item>
        </a-col>

        <a-col :xl="8" :xxl="6">
          <a-form-item label="业务类型">
            <a-select
              v-decorator="['operation_type']"
              :loading="loadingOperationTypeOptions"
              allow-clear
              @focus="fetchOperationTypeOptions"
            >
              <a-select-option
                v-for="o in operationTypeOptions"
                :key="o.value"
                :value="o.value"
              >
                {{ o.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :xl="8" :xxl="6">
          <a-form-item label="支付方式">
            <a-select
              v-decorator="['pay_way']"
              allow-clear
            >
              <a-select-option
                v-for="option in payWayOptions"
                :key="option.slug"
                :value="option.slug"
              >
                {{ option.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :xl="8" :xxl="6">
          <a-form-item label="支付用户">
            <a-input
              v-decorator="['pay_user_name', { normalize: this.$lodash.trim }]"
              allow-clear
            />
          </a-form-item>
        </a-col>

        <a-col :xl="8" :xxl="6">
          <a-form-item label="ICCID">
            <a-input
              v-decorator="['iccid', { normalize: this.$lodash.trim }]"
              allow-clear
            />
          </a-form-item>
        </a-col>

        <a-col :xl="8" :xxl="6">
          <a-form-item label="支付时间">
            <a-range-picker
              v-decorator="['paid_at']"
              style="width: 100%;"
              allow-clear
            />
          </a-form-item>
        </a-col>

        <a-col :span="24" :xxl="12">
          <a-form-item>
            <a-space>
              <a-button type="primary" html-type="submit">
                搜索
              </a-button>
              <a-button @click="handleReset">
                刷新
              </a-button>
            </a-space>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import { formatRangeBeginDate, formatRangeEndDate } from '@/utils/time'
import {
  findFinanceLedgerOpenChannelOperationTypeOptions,
  findFinanceLedgerOpenChannelPayWayOptions
} from '@/api/finance_ledger'

export default {
  name: 'SearchFinanceLedgerOpenChannelPayments',
  data() {
    return {
      form: this.$form.createForm(this),
      operationTypeOptions: [],
      payWayOptions: findFinanceLedgerOpenChannelPayWayOptions(),
      loadingOperationTypeOptions: false
    }
  },
  methods: {
    fetchOperationTypeOptions() {
      if (this.operationTypeOptions.length > 0) {
        return
      }
      this.loadingOperationTypeOptions = true
      findFinanceLedgerOpenChannelOperationTypeOptions().then((res) => {
        if (res.code === 0) {
          this.operationTypeOptions = res.data
        }
        this.loadingOperationTypeOptions = false
      })
    },

    handleSearch(e) {
      e.preventDefault()
      const fieldsValue = this.form.getFieldsValue()
      const values = {
        ...fieldsValue,
        paid_at_begin: formatRangeBeginDate(fieldsValue.paid_at),
        paid_at_end: formatRangeEndDate(fieldsValue.paid_at)
      }
      delete values.paid_at
      this.$emit('submit', values)
    },

    handleReset() {
      this.form.resetFields()
      this.$emit('submit', {})
    }
  }
}
</script>
